var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.5C1.5 4.18629 4.18629 1.5 7.5 1.5C8.97685 1.5 10.3291 2.03358 11.3744 2.91847L2.91847 11.3744C2.03358 10.3291 1.5 8.97685 1.5 7.5ZM3.62558 12.0815L12.0815 3.62558C12.9664 4.67092 13.5 6.02315 13.5 7.5C13.5 10.8137 10.8137 13.5 7.5 13.5C6.02315 13.5 4.67092 12.9664 3.62558 12.0815ZM7.5 0.5C3.63401 0.5 0.5 3.63401 0.5 7.5C0.5 11.366 3.63401 14.5 7.5 14.5C11.366 14.5 14.5 11.366 14.5 7.5C14.5 3.63401 11.366 0.5 7.5 0.5Z"
  })));
}
export default SvgCommonIconBlock;